// src/component/HrvPage.jsx

// HRV展示组件
// Heart Rate Variability

import React from 'react'
import { NEW_RECORD_SYSTEM, ROLE } from '../services/Macro';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { DataApi } from '../services/Api';
import axios from 'axios';
import { strUtil } from '../utils/StrUtil';
import { mathUtil } from '../utils/MathUtil';
import { browserUtil } from '../utils/BrowserUtil';
import { Global } from '../services/Global';
import { componentUtil } from '../utils/ComponentUtil';
import { hrvUtil } from '../utils/HrvUtil';
import { encrypUtil } from '../utils/EncrypUtil';
import { Page } from '../services/Page';
import { checker } from '../utils/Checker';

const HRV2 = {
    rmssd: {
        type: 1,
        title: 'RMSSD(ms)',
        scale: [15, 20, 25],
    },
    sdnn: {
        type: 2,
        title: 'SDNN(ms)',
        scale: [25, 50, 75],
    },
    pnn50: {
        type: 3,
        title: 'pNN50(%)',
        scale: [15, 20, 25],
    },
    acc: {
        title: 'ACC',
        scale: [1, 1.5, 2],
    },
}

export default class HrvPage extends React.Component {

    state = {
        /** 画布宽度(像素) */
        canvasWidth: 1120,
        /** ECG画布高度(像素) */
        ecgCanvasHeight: 260,
        /** ACC画布高度(像素) */
        accCanvasHeight: 370,
        /** ACC图表高度(像素) */
        accChartHeight: 330,
        /** IHR图表高度(像素) */
        ihrHeight: 200,
        /** ACC图表Z轴负方向多余量 */
        accZPlusHeight: 30,
        /** 边框尺寸(像素) */
        frameWidth: 40,
        frameHeight: 20,
        zoomX: 1,
        zoomY: 1,
        step: 0,
        /** 最大步数 */
        max: 400,
        /** 滑块标注数组 */
        marks: {},
        samplePerPage: 0,
        samplePerJumpPage: 0,
        samplePerSecond: 0,
        samplePerStep: 1,
        sampleCount: 1,

        /** 记录信息 */
        record: { nickname: "", size: 0, startTime: "00:00:00", timeLength: "00:00:00" },


        // 控制加载中的弹框
        showLoading: false,
        showAcc: false,
        selectHrv2: 'RMSSD(ms)',
        selectHrv2Type: 'rmssd',
        parseProgress: 0,
        fetchProgress: 0,
        scaleIhr: 1,
        scaleRmssd: 1,
        scaleSdnn: 1,
        scalePnn50: 1,
        scaleAcc: 1,
        continueUpdate: true,
        startTime: 0,
        curTime: '00:00:00'
    }

    hrv2 = HRV2.rmssd.type
    baseIhr = 30
    baseRmssd = 15
    baseSdnn = 25
    basePnn50 = 15
    baseAcc = 1

    scaleIdx = {
        rmssd: this.state.scaleRmssd,
        pnn50: this.state.scalePnn50,
        sdnn: this.state.scaleSdnn,
    }

    /** 总的采样点数量 */
    allSampleCnt = 0
    /** 总的ACC采样点数量 */
    allAccSampleCnt = 0
    /** 数据块数量 */
    blockCnt = 0
    /** 起始块id */
    blockIdFirst = 0
    /** 结束块id */
    blockIdLast = 0
    /** 总的记录时长 */
    totalRecordTime = 0
    /** ACC X */
    accXList = []
    /** ACC Y */
    accYList = []
    /** ACC Z */
    accZList = []

    /** IHR(Intrinsic Heart Rate) 固有心率数组，每采样一个?每分钟一个? */
    ihrList = []
    /** RMSSD30 */
    rmssd30List = []
    /** RMSSD60 */
    rmssd60List = []
    /** RMSSD300 */
    rmssd300List = []
    /** SDNN30 */
    sdnn30List = []
    /** SDNN60 */
    sdnn60List = []
    /** SDNN300 */
    sdnn300List = []
    /** pNN50_30 */
    pNN50_30List = []
    /** pNN50_60 */
    pNN50_60List = []
    /** pNN50_300 */
    pNN50_300List = []

    /** 心跳峰值数组，标识在第n个采样点会有一个峰值 */
    peekIndexList = []
    /** 来自服务器返回的原始数据 */
    samples = {}
    /** 记录的总时长(单位:秒) */
    timeLengthSecond = 0
    /** ACC数据每秒样本数(单位:样本/秒) */
    accSamplePerSecond = 0
    /** 每个滑块步长代表的秒数 */
    secondsPerSliderStep = 1
    /** 当前最左侧显示的是第几秒 */
    timeSecond = 0
    /** 采样频率，次/秒 */
    rate = 512
    accRate = 25
    /** 服务器请求堆栈 */
    requestStack = []
    /** 是否请求中，如果是请求中，不应该连续发送请求 */
    isRequesting = false
    /** 使用者信息 */
    userInfo = []
    /** 设备信息 */
    deviceInfo = []
    /** 数据信息 */
    dataInfo = []
    /** 数据块信息 */
    blockInfo = []
    headerSize = 645
    /** ACC数值与幂=8时的倍数 */
    gn8Rate = 1
    /** ACC数值的幂 */
    gn = 1

    /** 已经加载的页数 */
    page = 1

    componentWillMount() {
        // 组件挂载前获取的屏幕尺寸真实可信
        Global.windowWidth = window.innerWidth
        console.log(`windowWidth:`, Global.windowWidth)
        Global.isMobile = browserUtil.checkMobile()
        if (Global.isMobile) {
            // this.state.canvasWidth = Global.windowWidth
            this.setState({ canvasWidth: Global.windowWidth })
            // this.state.max = 400
            this.setState({ max: 400 })
        }
        this.requestInfo()
        this.getHrvPageFromServer()
        // this.state.continueUpdate = true
        this.setState({ continueUpdate: true })
    }

    componentWillUnmount() {
        // this.state.continueUpdate = false
        this.setState({ continueUpdate: false })
    }

    async getHrvPageFromServer() {
        const DEBUG = false
        const TAG = `HrvPage.getHrvPageFromServer() - `
        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || 'zh_CN'
        const searchParams = new URLSearchParams(window.location.search)
        const url = searchParams.get('url')
        console.time('获取HRV数据')
        let requestData = {
            role: ROLE.SUPER,
            token: token,
            url: url,
            lang: lang.split('_')[0],
            page: this.page,
            size: 500
        }
        if (NEW_RECORD_SYSTEM) requestData.newRecord = true
        let params = await encrypUtil.encodeRequestRsa(requestData)
        const response = await axios.post(DataApi.GET_HRV_PAGE, params)
        console.timeEnd('获取HRV数据')// 15000个采样点，一次获取数据用时24秒!
        let retData = response.data.data
        DEBUG && console.log(TAG, `服务器返回数据:\n`, retData)
        DEBUG && console.log(TAG, `当前加载进度:`, retData.progress)
        // this.state.parseProgress = retData.progress / 100
        this.setState({ parseProgress: retData.progress / 100 })
        if (retData.progress < 10000) {
            if (this.state.continueUpdate) {
                setTimeout(() => {
                    this.getHrvPageFromServer()
                }, 500)
            }
        }
        else {
            DEBUG && console.log(TAG, `加载完毕，显示数据`)
            // 解析 ACC 数据
            let accTotal = 0
            if (retData.accData) {
                let dataList = [
                    { type: 'accX', array: this.accXList },
                    { type: 'accY', array: this.accYList },
                    { type: 'accZ', array: this.accZList },
                ]
                accTotal = retData.accData.total
                // 每秒的 ACC 样本数
                this.accSamplePerSecond = Math.round(accTotal / this.timeLengthSecond)
                for (let i = 0; i < dataList.length; i++) {
                    const dataE = dataList[i]
                    let list = retData.accData[dataE.type]
                    for (let i = 0; i < list.length; i++) {
                        dataE.array.push(list[i])
                    }
                }
            }
            // 计算滑块标尺
            this.state.marks = {}
            let stepTimes = this.state.max / 100
            let durationPerStep = this.timeLengthSecond / 10// 1/10 的长度是多少秒
            for (let i = 0; i <= 10; i++) {
                let mark = i * 10 * stepTimes
                let time = strUtil.formatTime((this.state.startTime + i * durationPerStep) * 1000, 'HH:mm:ss')
                this.state.marks[mark] = `${Math.floor(i * durationPerStep)}s/${time}`
            }
            this.setState({ curTime: strUtil.formatTime(this.state.startTime * 1000, 'HH:mm:ss') })

            // 解析 HRV 数据
            if (retData.hrvData) {
                let thisPeekIndex = retData.hrvData.peekIndex
                for (let i = 0; i < thisPeekIndex.length; i++) {
                    const peek = thisPeekIndex[i]
                    this.peekIndex.push(peek)
                }
                // 手动计算 SDNN
                let peekList = hrvUtil.formatPeek(this.rate, this.peekIndex)
                let rrList = hrvUtil.calcRr(this.rate, peekList)
                let sdnn_30 = hrvUtil.calcSdnn(30, rrList)
                let sdnn_60 = hrvUtil.calcSdnn(60, rrList)
                let sdnn_300 = hrvUtil.calcSdnn(300, rrList)

                this.sdnn30List = []
                for (let i = 0; i < sdnn_30.length; i++) {
                    this.sdnn30List.push({
                        x: this.peekIndex[i],
                        y: sdnn_30[i][2]
                    })
                }
                DEBUG && console.log(TAG, `sdnn_30:\n`, this.sdnn30List)

                this.sdnn60List = []
                for (let i = 0; i < sdnn_60.length; i++) {
                    this.sdnn60List.push({
                        x: this.peekIndex[i],
                        y: sdnn_60[i][2]
                    })
                }
                DEBUG && console.log(TAG, `sdnn_60:\n`, this.sdnn60List)

                this.sdnn300List = []
                for (let i = 0; i < sdnn_300.length; i++) {
                    this.sdnn300List.push({
                        x: this.peekIndex[i],
                        y: sdnn_300[i][2]
                    })
                }
                DEBUG && console.log(TAG, `sdnn_300:\n`, this.sdnn300List)

                // 手工计算 pNN50
                const nn50List = hrvUtil.calcNn50(rrList)
                const pnn50_30 = hrvUtil.calcPnn50(30, rrList, nn50List)
                const pnn50_60 = hrvUtil.calcPnn50(60, rrList, nn50List)
                const pnn50_300 = hrvUtil.calcPnn50(300, rrList, nn50List)

                this.pNN50_30List = []
                for (let i = 0; i < pnn50_30.length; i++) {
                    this.pNN50_30List.push({
                        x: this.peekIndex[i],
                        y: pnn50_30[i][2]
                    })
                }
                DEBUG && console.log(TAG, `pnn50_30:\n`, this.pNN50_30List)

                this.pNN50_60List = []
                for (let i = 0; i < pnn50_60.length; i++) {
                    this.pNN50_60List.push({
                        x: this.peekIndex[i],
                        y: pnn50_60[i][2]
                    })
                }
                DEBUG && console.log(TAG, `pnn50_60:\n`, this.pNN50_60List)

                this.pNN50_300List = []
                for (let i = 0; i < pnn50_300.length; i++) {
                    this.pNN50_300List.push({
                        x: this.peekIndex[i],
                        y: pnn50_300[i][2]
                    })
                }
                DEBUG && console.log(TAG, `pnn50_300:\n`, this.pNN50_300List)

                let dataList = [
                    { type: 'ihr', array: this.ihrList },
                    { type: 'rmssd30', array: this.rmssd30List },
                    { type: 'rmssd60', array: this.rmssd60List },
                    { type: 'rmssd300', array: this.rmssd300List },
                    // { type: 'sdnn30', array: this.sdnn30List },
                    // { type: 'sdnn60', array: this.sdnn60List },
                    // { type: 'sdnn300', array: this.sdnn300List },
                    // { type: 'pnn50_30', array: this.pNN50_30List },
                    // { type: 'pnn50_60', array: this.pNN50_60List },
                    // { type: 'pnn50_300', array: this.pNN50_300List }
                ]
                // hrvTotal = retData.hrvData.total
                for (let i = 0; i < dataList.length; i++) {
                    const dataE = dataList[i]
                    let list = retData.hrvData[dataE.type]
                    if (list.length !== thisPeekIndex.length) {
                        console.error(TAG, `数据长度不匹配: ${dataE.type}.length:${list.length}, thisPeekIndex.length:${thisPeekIndex.length}`)
                    }
                    else {
                        if (dataE.type === 'ihr') {
                            for (let i = 0; i < thisPeekIndex.length; i++) {
                                const sampleIdx = thisPeekIndex[i]
                                dataE.array.push({
                                    x: sampleIdx,
                                    y: list[i]
                                })
                            }
                        }
                        else if (dataE.type.startsWith('rmssd')) {
                            if (dataE.array.length === 0) {
                                console.log(TAG, `初始化 sdnn 数组`)
                                dataE.array.push({ x: 0, y: 0 })
                            }
                            const offset = 55 * 256
                            // DEBUG &&
                            console.log(TAG, `offset:`, offset)
                            for (let i = 0; i < thisPeekIndex.length; i++) {
                                const sampleIdx = thisPeekIndex[i]
                                dataE.array.push({
                                    x: sampleIdx + offset,
                                    y: list[i]
                                })
                            }
                        }
                        else {
                            for (let i = 0; i < thisPeekIndex.length; i++) {
                                const sampleIdx = thisPeekIndex[i]
                                dataE.array.push({
                                    x: sampleIdx,
                                    y: list[i]
                                })
                            }
                        }
                    }
                }
                // this.state.fetchProgress = Math.min(Math.round(retData.hrvData.fetchProgress) / 100, 100)
                this.setState({ fetchProgress: Math.min(Math.round(retData.hrvData.fetchProgress) / 100, 100) })
                if (this.state.fetchProgress < 100) {
                    this.page += 1
                    this.getHrvPageFromServer()
                }
            }
            this.callDrawFromChild()
        }
    }

    ihr = []
    peekIndex = []

    componentDidMount() {
        this.props.onRef(this)
        this.callDrawFromChild()
    }

    /** 请求该用户信息，数据块信息. */
    requestInfo = async () => {
        const TAG = `HrvPage.requestInfo() - `
        let t = this.props.trans
        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || 'zh_CN'
        const searchParams = new URLSearchParams(window.location.search)
        const url = searchParams.get('url')
        let roleStr = localStorage.getItem('role') || `${ROLE.SUPER}`
        let role = roleStr == `${ROLE.SUPER}` ? ROLE.SUPER : ROLE.USER
        let isLogin = await checker.checkLogin(role, Page.hrvShow)
        if (isLogin) {
            let requestData = {
                role: ROLE.SUPER,
                token: token,
                url: url,
                lang: lang.split('_')[0],
            }
            if (NEW_RECORD_SYSTEM) requestData.newRecord = true
            let params = await encrypUtil.encodeRequestRsa(requestData)
            const response = await axios.post(DataApi.GET_RECORD_INFO, params)
            let retData = response.data.data
            console.log(TAG, `获取心电图信息:\n`, retData)
            let record = retData.record

            record.create = strUtil.formatTime(record.create)
            console.log(TAG, `meta:\n`, record.meta)
            record.rate = record.meta.rate || 512
            this.rate = record.rate
            record.size = strUtil.toM(record.size)
            record.timeLength = '00:00:00'
            record.nickname = ''
            if (record.meta) {
                if (record.meta.gn) {
                    this.gn8Rate = Math.pow(2, record.meta.gn - 8)
                    this.gn = record.meta.gn
                }
                if (record.meta.timeLength) {
                    console.log(TAG, `record.meta.timeLength:`, record.meta.timeLength)
                    this.timeLengthSecond = record.meta.timeLength
                    // this.secondsPerSliderStep = Math.max((this.timeLengthSecond - 600) / this.state.max, 1)
                    this.secondsPerSliderStep = Math.max(this.timeLengthSecond / this.state.max, 1)
                    record.timeLength = strUtil.formatDuration(record.meta.timeLength)
                }
                if (record.meta.name) record.nickname = record.meta.name
                if (record.meta.startTime) {
                    record.startTime = strUtil.formatTime(record.meta.startTime * 1000)
                    this.setState({ startTime: record.meta.startTime })
                }
                if (record.meta.firmwareVersion) {
                    console.log(TAG, `firmwareVersion:`, record.meta.firmwareVersion)
                    let infoList = record.meta.firmwareVersion.split('_')
                    let versionType = infoList[0]
                    record.firmwareType = versionType
                    let versionStr = infoList[2]
                    console.log(TAG, `versionType:`, versionType)
                    console.log(TAG, `versionStr:`, versionStr)
                    console.log(TAG, `parseInt(versionStr):`, parseInt(versionStr))
                    if (versionType === 'CA' && parseInt(versionStr) >= 2) {
                        this.gn8Rate = Math.pow(2, 13 - 8)
                    }
                    else if (versionType === 'CB' && parseInt(versionStr) >= 5) {
                        this.gn8Rate = Math.pow(2, 13 - 8)
                    }
                }
            }

            let blockInfo = retData.blockInfo
            let allSampleCnt = 0
            let blockCount = 0
            let blockIdFirst = 0
            let blockIdLast = 0
            if (blockInfo) {
                allSampleCnt = blockInfo.allSampleCnt
                blockCount = blockInfo.blockCount
                blockIdFirst = blockInfo.blockIdFirst
                blockIdLast = blockInfo.blockIdLast
            }
            console.log(TAG, `gn8Rate:`, this.gn8Rate)

            console.log(TAG, `record:\n`, record)
            this.setState({ record: record })

            this.userInfo = [
                {
                    key: t('nickname'),
                    val: record.nickname
                },
                {
                    key: t('terminalType'),
                    val: Global.isMobile ? t('mobileTerminal') : t('pcTerminal')
                },
            ]

            this.deviceInfo = [
                {
                    key: 'MAC',
                    val: record.device
                },
                {
                    key: t('firmwareType'),
                    val: record.firmwareType
                },
            ]

            this.dataInfo = [
                {
                    key: t('size'),
                    val: record.size
                },
                {
                    key: t('startTime'),
                    val: record.startTime
                },
                {
                    key: t('timeLength'),
                    val: record.timeLength
                },
                {
                    key: t('sampleRate'),
                    val: record.rate
                },
            ]

            this.blockInfo = [
                {
                    key: t('sampleCnt'),
                    val: allSampleCnt
                },
                {
                    key: t('blockCnt'),
                    val: blockCount
                },
                {
                    key: t('blockIdFirst'),
                    val: blockIdFirst
                },
                {
                    key: t('blockIdLast'),
                    val: blockIdLast
                },
                {
                    key: t('lackBlock'),
                    val: t('none')
                },
                {
                    key: t('invalidBlock'),
                    val: t('none')
                },
            ]
        }
    }

    // =============================================================================
    // 导航ECG时间轴后的数据处理(翻页，跳秒，拖动)
    // =============================================================================

    /** 处理拖动后的ECG数据请求 */
    handleChange = async (step) => {
        const DEBUG = true
        const TAG = `HrvPage.handleChange() - `
        DEBUG && console.log(TAG, `step:`, step)
        // this.state.step = step
        this.setState({ step: step })
        this.timeSecond = Math.floor(this.secondsPerSliderStep * step)
        DEBUG && console.log(TAG, `timeSecond:`, this.timeSecond)
        this.setState({ curTime: strUtil.formatTime((this.state.startTime + this.timeSecond) * 1000, 'HH:mm:ss') })
        this.draw()
    }

    /** 翻页或跳秒后检查是否已经到达ECG图表的最后位置. */
    checkEnd = () => {
        const TAG = `HrvPage.checkEnd() - `
        let stepPerPage = this.state.samplePerJumpPage / this.state.samplePerStep
        if (this.timeSecond > this.totalRecordTime - 10) this.timeSecond = this.totalRecordTime - 10
        if (this.state.step > this.state.max - stepPerPage) {
            // this.state.step = this.state.max - stepPerPage
            console.log(TAG, `new step:`, this.state.max - stepPerPage)
            this.setState({ step: this.state.max - stepPerPage })
        }
    }

    /** 父组件调用 showLoading() */
    callShowLoadingFromParent() {
        this.showLoading()
    }

    /** 父组件调用 closeLoading() */
    callCloseLoadingFromParent() {
        this.closeLoading()
    }

    /** 显示"加载中..." */
    showLoading = () => {
        // this.state.showLoading = true
        this.setState({ showLoading: true })
    }

    /** 关闭"加载中..." */
    closeLoading = () => {
        // this.state.showLoading = false
        this.setState({ showLoading: false })
    }

    /** 子组件调用 draw() */
    callDrawFromChild() {
        // console.log(`来自子组件的调用`)
        this.draw()
    }

    clickScale = (type, idx, base) => {
        switch (type) {
            case 'ihr':
                // this.state.scaleIhr = idx
                this.setState({ scaleIhr: idx })
                this.baseIhr = base
                break
            case 'rmssd':
                // this.state.scaleRmssd = idx
                this.setState({ scaleRmssd: idx })
                this.baseRmssd = base
                break
            case 'sdnn':
                // this.state.scaleSdnn = idx
                this.setState({ scaleSdnn: idx })
                this.baseSdnn = base
                break
            case 'pnn50':
                // this.state.scalePnn50 = idx
                this.setState({ scalePnn50: idx })
                this.basePnn50 = base
                break
            case 'acc':
                // this.state.scaleAcc = idx
                this.setState({ scaleAcc: idx })
                this.baseAcc = base
                break
            default:
                break
        }
        this.scaleIdx = {
            rmssd: this.state.scaleRmssd,
            pnn50: this.state.scalePnn50,
            sdnn: this.state.scaleSdnn,
        }
        this.draw()
    }

    clickPnn50 = (event) => {
        console.log('clickPnn50')
        this.hrv2 = HRV2.pnn50.type
        // this.state.selectHrv2 = 'pNN50(%)'
        this.setState({ selectHrv2: 'pNN50(%)' })
        // this.state.selectHrv2Type = 'pnn50'
        this.setState({ selectHrv2Type: 'pnn50' })
        this.draw()
    }

    clickSdnn = (event) => {
        console.log('clickSdnn')
        this.hrv2 = HRV2.sdnn.type
        // this.state.selectHrv2 = 'SDNN(ms)'
        this.setState({ selectHrv2: 'SDNN(ms)' })
        // this.state.selectHrv2Type = 'sdnn'
        this.setState({ selectHrv2Type: 'sdnn' })
        this.draw()
    }

    clickRmssd = (event) => {
        console.log('clickRmssd')
        this.hrv2 = HRV2.rmssd.type
        // this.state.selectHrv2 = 'RMSSD(ms)'
        this.setState({ selectHrv2: 'RMSSD(ms)' })
        // this.state.selectHrv2Type = 'rmssd'
        this.setState({ selectHrv2Type: 'rmssd' })
        this.draw()
    }

    /** 绘制图表 */
    draw() {
        this.drawIhr()
        switch (this.hrv2) {
            case HRV2.rmssd.type:
                this.drawRmssd()
                break
            case HRV2.sdnn.type:
                this.drawSdnn()
                break
            case HRV2.pnn50.type:
                this.drawPnn50()
                break
            default:
                break
        }
        this.drawAcc()
    }

    /** 绘制ACC图表 */
    drawAcc() {
        const DEBUG = false
        const TAG = `HrvPage.drawAcc() - `
        let canvas = document.getElementById('acc')
        if (!canvas.getContext) return
        DEBUG && console.log(TAG, `获取到ACC的画布，绘制画布内容`)
        var ctx = canvas.getContext("2d")
        this.drawCoordinateSystem(ctx)
        this.drawTimeLine(ctx)
        this.drawAccY(ctx)
        this.drawAccSample(ctx)
    }

    drawAccY(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawAccY() - `
        const { frameWidth, frameHeight, ihrHeight: canvasHeight } = this.state

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        let accHeight = (canvasHeight - frameHeight * 2) / 4
        let count = -2
        const halfCharheight = 4
        const unit = Math.pow(2, this.gn) / 2 * this.baseAcc
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += accHeight) {
            const text = `${count * unit}`
            DEBUG && console.log(TAG, `text:`, text)
            const textWidth = ctx.measureText(text).width
            const x = frameWidth - textWidth - 4
            const y = canvasHeight - frameHeight - (count + 2) * accHeight + halfCharheight
            DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
            ctx.fillText(text, x, y)
            count++
        }
    }

    drawAccSample(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawAccSample() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制ACC采样点`)
        const settings = [
            { color: 'yellow', list: this.accXList },
            { color: 'green', list: this.accYList },
            { color: 'blue', list: this.accZList },
        ]

        // 1分钟间隔的坐标距离(采样率就是这一分钟有60个采样率那么多)
        let width60 = (canvasWidth - frameWidth * 2) / 10
        let heightUnit = (canvasHeight - frameHeight * 2) / 4
        // ACC 采样频率: 总的采样点数 / 时长(秒)
        let accRate = this.accSamplePerSecond
        // 一个采样点的距离
        let xPerSample = width60 / 60 / accRate
        const unit = Math.pow(2, this.gn) / 2 * this.baseAcc
        let yPerBpm = heightUnit / unit
        DEBUG && console.log(TAG, `xPerSample:`, xPerSample)
        DEBUG && console.log(TAG, `accRate:`, accRate)

        let startSample = accRate * this.timeSecond
        let endSample = accRate * (this.timeSecond + 600)
        let offset = startSample * xPerSample
        DEBUG && console.log(TAG, `startSample:`, startSample)
        DEBUG && console.log(TAG, `endSample:`, endSample)
        DEBUG && console.log(TAG, `offset:`, offset)
        let lw = 0.5
        if (Global.isMobile) lw = 0.2
        for (let idx = 0; idx < settings.length; idx++) {
            const ele = settings[idx]
            ctx.strokeStyle = ele.color
            const maxSample = Math.min(ele.list.length - 1, endSample)
            DEBUG && console.log(TAG, `maxSample:`, maxSample)
            for (let i = startSample; i < maxSample; i++) {
                let curPoint = ele.list[i]
                let nextPoint = ele.list[i + 1]
                let x1 = i * xPerSample + frameWidth - offset
                let x2 = (i + 1) * xPerSample + frameWidth - offset
                // 注意：这里的圆点在中间
                let y1 = canvasHeight / 2 - curPoint * yPerBpm
                let y2 = canvasHeight / 2 - nextPoint * yPerBpm
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
                if (i === maxSample - 1) DEBUG && console.log(TAG, `x2:`, x2)
            }
        }
    }

    /** 绘制IHR图表 */
    drawIhr() {
        const DEBUG = false
        const TAG = `HrvPage.drawIhr() - `
        let canvas = document.getElementById('ihr')
        if (!canvas.getContext) return
        DEBUG && console.log(TAG, `获取到IHR的画布，绘制画布内容`)
        var ctx = canvas.getContext("2d")
        this.drawCoordinateSystem(ctx)
        this.drawTimeLine(ctx)
        this.drawIhrY(ctx)
        this.drawIhrSample(ctx)
    }

    drawRmssd() {
        const DEBUG = false
        const TAG = `HrvPage.drawRmssd() - `
        let canvas = document.getElementById('hrv2')
        if (!canvas.getContext) return
        DEBUG && console.log(TAG, `获取到 RMSSD 的画布，绘制画布内容`)
        var ctx = canvas.getContext("2d")
        this.drawCoordinateSystem(ctx)
        this.drawTimeLine(ctx)
        this.drawRmssdY(ctx)
        this.drawRmssdSample(ctx)
    }

    drawSdnn() {
        const DEBUG = true
        const TAG = `HrvPage.drawSdnn() - `
        let canvas = document.getElementById('hrv2')
        if (!canvas.getContext) return
        DEBUG && console.log(TAG, `获取到 SDNN 的画布，绘制画布内容`)
        var ctx = canvas.getContext("2d")
        this.drawCoordinateSystem(ctx)
        this.drawTimeLine(ctx)
        this.drawSdnnY(ctx)
        this.drawSdnnSample(ctx)
    }

    drawPnn50() {
        const DEBUG = true
        const TAG = `HrvPage.drawPnn50() - `
        let canvas = document.getElementById('hrv2')
        if (!canvas.getContext) return
        DEBUG && console.log(TAG, `获取到 pNN50 的画布，绘制画布内容`)
        var ctx = canvas.getContext("2d")
        this.drawCoordinateSystem(ctx)
        this.drawTimeLine(ctx)
        this.drawPnn50Y(ctx)
        this.drawPnn50Sample(ctx)
    }

    drawIhrSample(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawIhrSample() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制IHR采样点`)
        ctx.strokeStyle = 'red'

        // 1分钟间隔的坐标距离(采样率就是这一分钟有60个采样率那么多)
        let ihrWidth60 = (canvasWidth - frameWidth * 2) / 10
        let ihrHeightBase = (canvasHeight - frameHeight * 2) / 4
        // 一个采样点的距离
        let xPerSample = ihrWidth60 / 60 / this.rate
        let yPerBpm = ihrHeightBase / this.baseIhr
        DEBUG && console.log(TAG, `xPerSample:`, xPerSample)
        DEBUG && console.log(TAG, `this.rate:`, this.rate)

        let startSample = this.rate * this.timeSecond
        let endSample = this.rate * (this.timeSecond + 600)
        let offset = startSample * xPerSample
        for (let i = 0; i < this.ihrList.length - 1; i++) {
            let curPoint = this.ihrList[i]
            let nextPoint = this.ihrList[i + 1]
            if (nextPoint.x >= startSample && nextPoint.x <= endSample) {
                let lw = 1
                let x1 = curPoint.x * xPerSample + frameWidth - offset
                let x2 = nextPoint.x * xPerSample + frameWidth - offset
                let y1 = canvasHeight - frameHeight - curPoint.y * yPerBpm
                let y2 = canvasHeight - frameHeight - nextPoint.y * yPerBpm
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            if (nextPoint.x > endSample) {
                break
            }
        }
    }

    drawRmssdSample(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawRmssdSample() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制 RMSSD 采样点`)

        // 1分钟间隔的坐标距离(采样率就是这一分钟有60个采样率那么多)
        let rmssdWidth60 = (canvasWidth - frameWidth * 2) / 10
        let rmssdHeightBase = (canvasHeight - frameHeight * 2) / 4
        // 一个采样点的距离
        let xPerSample = rmssdWidth60 / 60 / this.rate
        let yPerData = rmssdHeightBase / this.baseRmssd
        DEBUG && console.log(TAG, `xPerSample:`, xPerSample)
        DEBUG && console.log(TAG, `this.rate:`, this.rate)

        let rmssdList = [
            { color: 'green', list: this.rmssd30List },
            { color: 'red', list: this.rmssd60List },
            { color: 'blue', list: this.rmssd300List }
        ]

        let startSample = this.rate * this.timeSecond
        let endSample = this.rate * (this.timeSecond + 600)
        let offset = startSample * xPerSample
        for (let idx = 0; idx < rmssdList.length; idx++) {
            const listE = rmssdList[idx]
            ctx.strokeStyle = listE.color
            for (let i = 0; i < listE.list.length - 1; i++) {
                let curPoint = listE.list[i]
                let nextPoint = listE.list[i + 1]
                if (nextPoint.x >= startSample && nextPoint.x <= endSample) {
                    let lw = 1
                    let x1 = curPoint.x * xPerSample + frameWidth - offset
                    let x2 = nextPoint.x * xPerSample + frameWidth - offset
                    let y1 = canvasHeight - frameHeight - curPoint.y * yPerData
                    let y2 = canvasHeight - frameHeight - nextPoint.y * yPerData
                    this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
                }
                if (nextPoint.x > endSample) {
                    break
                }
            }
        }
    }

    drawSdnnSample(ctx) {
        const DEBUG = true
        const TAG = `HrvPage.drawSdnnSample() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制 SDNN 采样点`)

        // 1分钟间隔的坐标距离(采样率就是这一分钟有60个采样率那么多)
        let sdnnWidth60 = (canvasWidth - frameWidth * 2) / 10
        let sdnnHeight50 = (canvasHeight - frameHeight * 2) / 4
        // 一个采样点的距离
        let xPerSample = sdnnWidth60 / 60 / this.rate
        let yPerData = sdnnHeight50 / this.baseSdnn
        DEBUG && console.log(TAG, `xPerSample:`, xPerSample)
        DEBUG && console.log(TAG, `this.rate:`, this.rate)

        let sdnnList = [
            { color: 'green', list: this.sdnn30List },
            { color: 'red', list: this.sdnn60List },
            { color: 'blue', list: this.sdnn300List }
        ]

        let startSample = this.rate * this.timeSecond
        let endSample = this.rate * (this.timeSecond + 600)
        let offset = startSample * xPerSample
        for (let idx = 0; idx < sdnnList.length; idx++) {
            const listE = sdnnList[idx]
            ctx.strokeStyle = listE.color
            for (let i = 0; i < listE.list.length - 1; i++) {
                let curPoint = listE.list[i]
                let nextPoint = listE.list[i + 1]
                if (nextPoint.x >= startSample && nextPoint.x <= endSample) {
                    let lw = 1
                    let x1 = curPoint.x * xPerSample + frameWidth - offset
                    let x2 = nextPoint.x * xPerSample + frameWidth - offset
                    let y1 = canvasHeight - frameHeight - mathUtil.toUByte(curPoint.y) * yPerData
                    let y2 = canvasHeight - frameHeight - mathUtil.toUByte(nextPoint.y) * yPerData
                    this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
                }
                if (nextPoint.x > endSample) {
                    break
                }
            }
        }
    }

    drawPnn50Sample(ctx) {
        const DEBUG = true
        const TAG = `HrvPage.drawPnn50Sample() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制 pNN50 采样点`)

        // 1分钟间隔的坐标距离(采样率就是这一分钟有60个采样率那么多)
        let pnn50Width60 = (canvasWidth - frameWidth * 2) / 10
        let pnn50Height25 = (canvasHeight - frameHeight * 2) / 4
        // 一个采样点的距离
        let xPerSample = pnn50Width60 / 60 / this.rate
        let yPerData = pnn50Height25 / this.basePnn50
        DEBUG && console.log(TAG, `xPerSample:`, xPerSample)
        DEBUG && console.log(TAG, `this.rate:`, this.rate)

        let sdnnList = [
            { color: 'green', list: this.pNN50_30List },
            { color: 'red', list: this.pNN50_60List },
            { color: 'blue', list: this.pNN50_300List }
        ]

        let startSample = this.rate * this.timeSecond
        let endSample = this.rate * (this.timeSecond + 600)
        let offset = startSample * xPerSample
        for (let idx = 0; idx < sdnnList.length; idx++) {
            const listE = sdnnList[idx]
            ctx.strokeStyle = listE.color
            for (let i = 0; i < listE.list.length - 1; i++) {
                let curPoint = listE.list[i]
                let nextPoint = listE.list[i + 1]
                if (nextPoint.x >= startSample && nextPoint.x <= endSample) {
                    let lw = 1
                    let x1 = curPoint.x * xPerSample + frameWidth - offset
                    let x2 = nextPoint.x * xPerSample + frameWidth - offset
                    let y1 = canvasHeight - frameHeight - curPoint.y * yPerData
                    let y2 = canvasHeight - frameHeight - nextPoint.y * yPerData
                    this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
                }
                if (nextPoint.x > endSample) {
                    break
                }
            }
        }
    }

    drawCoordinateSystem(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawCoordinateSystem() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        DEBUG && console.log(TAG, `绘制坐标系`)
        DEBUG && console.log(TAG, `canvasWidth:`, canvasWidth)
        DEBUG && console.log(TAG, `canvasHeight:`, canvasHeight)
        DEBUG && console.log(TAG, `frameWidth:`, frameWidth)
        DEBUG && console.log(TAG, `frameHeight:`, frameHeight)

        let drawMobile = () => {
            // 横线
            let ihrHeight30 = (canvasHeight - frameHeight * 2) / 4
            for (let i = frameHeight; i <= canvasHeight - frameHeight; i += ihrHeight30) {
                let x1 = frameWidth, x2 = canvasWidth - frameWidth
                let y1 = i
                let y2 = i

                let lw = 0.2
                if (i === canvasHeight - frameHeight) lw = 0.5
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            // 竖线(随着取样点的移动而移动)
            let ihrWidth60 = (canvasWidth - frameWidth * 2) / 10
            for (let i = frameWidth; i <= canvasWidth - frameWidth; i += ihrWidth60) {
                let x1 = i
                let x2 = i
                let y1 = frameHeight
                let y2 = canvasHeight - frameHeight

                let lw = 0.2
                if (i === frameWidth) lw = 0.5
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
        }

        let drawOnPc = () => {
            // 横线
            let ihrHeight30 = (canvasHeight - frameHeight * 2) / 4
            for (let i = frameHeight; i <= canvasHeight - frameHeight; i += ihrHeight30) {
                let x1 = frameWidth, x2 = canvasWidth - frameWidth
                let y1 = i
                let y2 = i

                let lw = 0.2
                if (i === canvasHeight - frameHeight) lw = 0.5
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
            // 竖线(随着取样点的移动而移动)
            let ihrWidth20 = Math.round((canvasWidth - frameWidth * 2) / 30)
            for (let i = frameWidth; i <= canvasWidth - frameWidth; i += ihrWidth20) {
                let x1 = i
                let x2 = i
                let y1 = frameHeight
                let y2 = canvasHeight - frameHeight

                let lw = 0.1
                if ((i - frameWidth) % (ihrWidth20 * 3) === 0) lw = 0.3
                if (i === frameWidth) lw = 0.5
                this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            }
        }

        // 绘制底板(白底)
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight)

        // 绘制网格(红线)
        ctx.strokeStyle = 'red'

        if (Global.isMobile) return drawMobile()
        else return drawOnPc()
    }

    drawTimeLine(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawTimeLine() - `
        const { frameWidth, frameHeight, canvasWidth, ihrHeight: canvasHeight } = this.state

        let drawMobile = () => {
            // 每一格代表一分钟(60s)
            let ihrWidth60 = (canvasWidth - frameWidth * 2) / 10
            let count = 0
            const charheight = 8
            for (let i = frameWidth; i <= canvasWidth - frameWidth; i += ihrWidth60) {
                if (count > 0) {
                    const text = `${count * 60}s`
                    const textWidth = ctx.measureText(text).width
                    const x = i - textWidth / 2
                    const y = canvasHeight - frameHeight + charheight + 4
                    DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                    ctx.fillText(text, x, y)
                }
                count++
            }
        }

        let drawOnPc = () => {
            // 每一格代表20秒(20s)
            let ihrWidth20 = (canvasWidth - frameWidth * 2) / 30
            let count = 0
            const charheight = 8
            for (let i = frameWidth; i <= canvasWidth - frameWidth; i += ihrWidth20) {
                if (count > 0) {
                    const text = `${count * 20}s`
                    const textWidth = ctx.measureText(text).width
                    const x = i - textWidth / 2
                    const y = canvasHeight - frameHeight + charheight + 4
                    DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                    ctx.fillText(text, x, y)
                }
                count++
            }
        }

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'

        if (Global.isMobile) return drawMobile()
        else return drawOnPc()
    }

    /** 绘制 Y 轴坐标的标记. */
    drawIhrY(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawIhrY() - `
        const { frameWidth, frameHeight, ihrHeight: canvasHeight } = this.state

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        // 每一格代表30bpm
        let ihrHeight30 = (canvasHeight - frameHeight * 2) / 4
        let count = 0
        const halfCharheight = 4
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += ihrHeight30) {
            if (count >= 0) {
                const text = `${count * this.baseIhr}`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - textWidth - 4
                const y = canvasHeight - frameHeight - count * ihrHeight30 + halfCharheight
                DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                ctx.fillText(text, x, y)
            }
            count++
        }
    }

    drawRmssdY(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawRmssdY() - `
        const { frameWidth, frameHeight, ihrHeight: canvasHeight } = this.state

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        // 每一格代表30bpm
        let rmssdHeight25 = (canvasHeight - frameHeight * 2) / 4
        let count = 0
        const halfCharheight = 4
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += rmssdHeight25) {
            if (count >= 0) {
                const text = `${count * this.baseRmssd}`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - textWidth - 4
                const y = canvasHeight - frameHeight - count * rmssdHeight25 + halfCharheight
                DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                ctx.fillText(text, x, y)
            }
            count++
        }
    }

    drawSdnnY(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawSdnnY() - `
        const { frameWidth, frameHeight, ihrHeight: canvasHeight } = this.state

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        // 每一格代表30bpm
        let sdnnHeight50 = (canvasHeight - frameHeight * 2) / 4
        let count = 0
        const halfCharheight = 4
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += sdnnHeight50) {
            if (count >= 0) {
                const text = `${count * this.baseSdnn}`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - textWidth - 4
                const y = canvasHeight - frameHeight - count * sdnnHeight50 + halfCharheight
                DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                ctx.fillText(text, x, y)
            }
            count++
        }
    }

    drawPnn50Y(ctx) {
        const DEBUG = false
        const TAG = `HrvPage.drawPnn50Y() - `
        const { frameWidth, frameHeight, ihrHeight: canvasHeight } = this.state

        ctx.fillStyle = 'black'
        ctx.strokeStyle = 'black'
        // 每一格代表30bpm
        let pnn50Height25 = (canvasHeight - frameHeight * 2) / 4
        let count = 0
        const halfCharheight = 4
        for (let i = frameHeight; i <= canvasHeight - frameHeight; i += pnn50Height25) {
            if (count >= 0) {
                const text = `${count * this.basePnn50}`
                const textWidth = ctx.measureText(text).width
                const x = frameWidth - textWidth - 4
                const y = canvasHeight - frameHeight - count * pnn50Height25 + halfCharheight
                DEBUG && console.log(TAG, `坐标(${text})绘制在: (${x}, ${y})`)
                ctx.fillText(text, x, y)
            }
            count++
        }
    }

    /** 绘制线条. */
    drawLine = (ctx, p1, p2, lw) => {
        ctx.beginPath()
        ctx.moveTo(p1.x, p1.y)
        ctx.lineTo(p2.x, p2.y)
        ctx.closePath()
        ctx.lineWidth = lw
        ctx.stroke()
    }

    showUserDetail = (target) => {
        const attrList = []
        for (let i = this.userInfo.length - 1; i >= 0; i--) {
            const e = this.userInfo[i]
            attrList.push({
                trName: `trUser${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.userInfo, attrList)
    }

    showDeviceDetail = (target) => {
        const attrList = []
        for (let i = this.deviceInfo.length - 1; i >= 0; i--) {
            const e = this.deviceInfo[i]
            attrList.push({
                trName: `trDevice${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.deviceInfo, attrList)
    }

    showDataDetail = (target) => {
        const attrList = []
        for (let i = this.dataInfo.length - 1; i >= 0; i--) {
            const e = this.dataInfo[i]
            attrList.push({
                trName: `trData${i}`,
                trTitle: e.key,
                trValue: e.val
            })
        }
        componentUtil.showTable(2, target, this.dataInfo, attrList)
    }

    showBlockDetail = (target) => {
        const attrList = []
        for (let i = this.blockInfo.length - 1; i >= 0; i--) {
            const user = this.blockInfo[i]
            attrList.push({
                trName: `trBlock${i}`,
                trTitle: user.key,
                trValue: user.val
            })
        }
        componentUtil.showTable(2, target, this.blockInfo, attrList)
    }

    // =============================================================================
    // 渲染界面
    // =============================================================================
    render() {
        if (Global.isMobile) return this.renderMobile()
        else return this.renderPc()
    }

    renderMobile() {
        let t = this.props.trans
        const { step, parseProgress, fetchProgress } = this.state;
        return (
            < div style={{ width: `${Global.windowWidth}px` }}>
                {/** 信息区1(使用者信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle className="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showUserDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('userInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区1(设备信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle className="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showDeviceDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('deviceInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区1(数据信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle className="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showDataDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('dataInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 信息区2(块信息) */}
                <table className="table table-bordered table-striped mb-none">
                    <thead>
                        <tr>
                            <th style={{ width: '20px' }}><i data-toggle className="fa fa-caret-down text-primary h5 m-none" style={{ cursor: 'pointer' }} onClick={(e) => { this.showBlockDetail(e.target) }}></i></th>
                            <th><font color="blue">{t('blockInfo')}</font></th>
                        </tr>
                    </thead>
                </table>
                {/** 加载提示区 */}
                <div>
                    {this.state.showLoading && <div><h1><font color="red">{t('loading')}</font></h1></div>}
                </div>
                <div>
                    <div style={{ "text-align": "center" }}>{t('analysis')}{t('colon')}{parseProgress}%</div>
                    <div className="progress light m-md">
                        <div className="progress-bar progress-bar-success" role="progressbar" aria-valuenow={parseProgress} aria-valuemin="0" aria-valuemax="100" style={{ width: `${parseProgress}%` }}>
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{ "text-align": "center" }}>{t('gain')}{t('colon')}{fetchProgress}%</div>
                    <div className="progress light m-md">
                        <div className="progress-bar progress-bar-success" role="progressbar" aria-valuenow={fetchProgress} aria-valuemin="0" aria-valuemax="100" style={{ width: `${fetchProgress}%` }}>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <hr className='devider' />
                    {/** 画布区 */}
                    {/** IHR(BPM)绘制 */}
                    <div className="ihr">
                        <canvas id="ihr" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.state.scaleIhr === 3 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 3, 50) }}>50</button>
                        <button style={{ marginLeft: '20px', color: this.state.scaleIhr === 2 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 2, 40) }}>40</button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.state.scaleIhr === 1 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 1, 30) }}>30</button>
                        <font size={5}>IHR(BMP)</font>
                    </div>
                    <hr className='devider' />
                    <div className="col-md-12">
                        <div className="row">
                            <button style={{ marginLeft: '30px', color: this.hrv2 === HRV2.pnn50.type ? 'red' : 'black' }} onClick={this.clickPnn50}>pNN50</button>
                            <button style={{ marginLeft: '20px', color: this.hrv2 === HRV2.sdnn.type ? 'red' : 'black' }} onClick={this.clickSdnn}>SDNN</button>
                            <button style={{ marginLeft: '20px', color: this.hrv2 === HRV2.rmssd.type ? 'red' : 'black' }} onClick={this.clickRmssd}>RMSSD</button>
                            <div className="fa fa-circle" style={{ color: '#00ff00', marginLeft: '20px' }}> 30 </div>
                            <div className="fa fa-circle" style={{ color: '#ff0000', marginLeft: '20px' }}> 60 </div>
                            <div className="fa fa-circle" style={{ color: '#0000ff', marginLeft: '20px' }}> 300 </div>
                        </div>
                    </div>
                    {/** RMSSD, SDNN, pNN50 绘制 */}
                    <div className="hrv2">
                        <canvas id="hrv2" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.scaleIdx[this.state.selectHrv2Type] === 3 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 3, HRV2[this.state.selectHrv2Type].scale[2]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[2]}
                        </button>
                        <button style={{ marginLeft: '20px', color: this.scaleIdx[this.state.selectHrv2Type] === 2 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 2, HRV2[this.state.selectHrv2Type].scale[1]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[1]}
                        </button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.scaleIdx[this.state.selectHrv2Type] === 1 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 1, HRV2[this.state.selectHrv2Type].scale[0]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[0]}
                        </button>
                        <font size={5}>{HRV2[this.state.selectHrv2Type].title}</font>
                    </div>
                    <hr className='devider' />
                    {/** ACC绘制 */}
                    <div className="acc">
                        <canvas id="acc" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.state.scaleAcc === 1 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 1, 1) }}>1</button>
                        <button style={{ marginLeft: '20px', color: this.state.scaleAcc === 2 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 2, 1.5) }}>1.5</button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.state.scaleAcc === 3 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 3, 2) }}>2</button>
                        <font size={5}>ACC(g/{Math.pow(2, this.gn)})</font>
                    </div>
                    <hr className='devider' />
                    <Slider
                        style={{ width: `${this.state.canvasWidth - this.state.frameWidth * 2}px`, marginLeft: `${this.state.frameWidth}px` }}
                        min={0}
                        max={this.state.max}
                        marks={this.state.marks}
                        value={Math.round(step)}
                        onChange={this.handleChange} />
                </div>
            </div >
        )
    }

    renderPc() {
        let t = this.props.trans
        const { step, parseProgress, fetchProgress } = this.state;
        return (
            < div className="panel-body" >
                <div className="col-md-2 col-lg-2 col-xl-2">
                    {/** 加载提示区 */}
                    <div>
                        {this.state.showLoading && <div><h1><font color="red">{t('loading')}</font></h1></div>}
                    </div>
                    <div>
                        <div style={{ "text-align": "center" }}>{t('analysis')}{t('colon')}{parseProgress}%</div>
                        <div className="progress light m-md">
                            <div className="progress-bar progress-bar-success" role="progressbar" aria-valuenow={parseProgress} aria-valuemin="0" aria-valuemax="100" style={{ width: `${parseProgress}%` }}>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{ "text-align": "center" }}>{t('gain')}{t('colon')}{fetchProgress}%</div>
                        <div className="progress light m-md">
                            <div className="progress-bar progress-bar-success" role="progressbar" aria-valuenow={fetchProgress} aria-valuemin="0" aria-valuemax="100" style={{ width: `${fetchProgress}%` }}>
                            </div>
                        </div>
                    </div>
                    {/** 信息区1(使用者信息) */}
                    <table className="table table-bordered table-striped mb-none">
                        <thead>
                            <tr>
                                <th colSpan={2}><font color="blue">{t('userInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.userInfo.map((item, index) => (
                                <tr key={index}>
                                    <td><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区1(设备信息) */}
                    <table className="table table-bordered table-striped mb-none" style={{ "table-layout": "fixed" }}>
                        <thead>
                            <tr>
                                <th><font color="blue">{t('deviceInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.deviceInfo.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ "word-wrap": "break-word" }}><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区1(数据信息) */}
                    <table className="table table-bordered table-striped mb-none">
                        <thead>
                            <tr>
                                <th colSpan={2}><font color="blue">{t('dataInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.dataInfo.map((item, index) => (
                                <tr key={index}>
                                    <td><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/** 信息区2(块信息) */}
                    <table className="table table-bordered table-striped mb-none">
                        <thead>
                            <tr>
                                <th colSpan={2}><font color="blue">{t('blockInfo')}</font></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.blockInfo.map((item, index) => (
                                <tr key={index}>
                                    <td><strong>{item.key}</strong>: {item.val}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-md-9 col-lg-9 col-xl-9">
                    {/** 画布区 */}
                    {/** IHR(BPM)绘制 */}
                    <div className="ihr">
                        <canvas id="ihr" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.state.scaleIhr === 3 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 3, 50) }}>50</button>
                        <button style={{ marginLeft: '20px', color: this.state.scaleIhr === 2 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 2, 40) }}>40</button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.state.scaleIhr === 1 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('ihr', 1, 30) }}>30</button>
                        <font size={5}>IHR(BMP)</font>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            <button style={{ marginLeft: '30px', color: this.hrv2 === HRV2.pnn50.type ? 'red' : 'black' }} onClick={this.clickPnn50}>pNN50</button>
                            <button style={{ marginLeft: '20px', color: this.hrv2 === HRV2.sdnn.type ? 'red' : 'black' }} onClick={this.clickSdnn}>SDNN</button>
                            <button style={{ marginLeft: '20px', color: this.hrv2 === HRV2.rmssd.type ? 'red' : 'black' }} onClick={this.clickRmssd}>RMSSD</button>
                            <div className="fa fa-circle" style={{ color: '#00ff00', marginLeft: '20px' }}> 30 </div>
                            <div className="fa fa-circle" style={{ color: '#ff0000', marginLeft: '20px' }}> 60 </div>
                            <div className="fa fa-circle" style={{ color: '#0000ff', marginLeft: '20px' }}> 300 </div>
                        </div>
                    </div>
                    {/** RMSSD, SDNN, pNN50 绘制 */}
                    <div className="hrv2">
                        <canvas id="hrv2" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.scaleIdx[this.state.selectHrv2Type] === 3 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 3, HRV2[this.state.selectHrv2Type].scale[2]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[2]}
                        </button>
                        <button style={{ marginLeft: '20px', color: this.scaleIdx[this.state.selectHrv2Type] === 2 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 2, HRV2[this.state.selectHrv2Type].scale[1]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[1]}
                        </button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.scaleIdx[this.state.selectHrv2Type] === 1 ? 'red' : 'black' }}
                            onClick={(e) => { this.clickScale(this.state.selectHrv2Type, 1, HRV2[this.state.selectHrv2Type].scale[0]) }}>
                            {HRV2[this.state.selectHrv2Type].scale[0]}
                        </button>
                        <font size={5}>{HRV2[this.state.selectHrv2Type].title}</font>
                    </div>
                    {/** ACC绘制 */}
                    <div className="acc">
                        <canvas id="acc" width={this.state.canvasWidth} height={this.state.ihrHeight} />
                    </div>
                    <div style={{ "text-align": "center" }}>
                        <font size={4} style={{ color: 'blue' }}>{this.state.curTime}</font>
                        <button style={{ marginLeft: '30px', color: this.state.scaleAcc === 1 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 1, 1) }}>1</button>
                        <button style={{ marginLeft: '20px', color: this.state.scaleAcc === 2 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 2, 1.5) }}>1.5</button>
                        <button style={{ marginLeft: '20px', marginRight: '20px', color: this.state.scaleAcc === 3 ? 'red' : 'black' }} onClick={(e) => { this.clickScale('acc', 3, 2) }}>2</button>
                        <font size={5}>ACC(g/{Math.pow(2, this.gn)})</font>
                    </div>
                    <Slider
                        style={{ width: `${this.state.canvasWidth - this.state.frameWidth * 2}px`, marginLeft: `${this.state.frameWidth}px` }}
                        min={0}
                        max={this.state.max}
                        marks={this.state.marks}
                        value={Math.round(step)}
                        onChange={this.handleChange} />
                </div>
            </div >
        )
    }
}